<div class="ui-input" style="margin-bottom: 0">
  @if (label()) {
    <label class="ui-label" [ngClass]="{ 'ui-label--required': required() }">{{ label() }}</label>
  }

  @if (addressDetails()) {
    <div class="address-info address-info--editable">
      <div class="icon-and-text" style="margin: 0">
        <pxw-icon class="map-marker" icon="map-marker" size="xs"></pxw-icon>
        <div class="text">
          <p>{{ addressDetails()!.fullAddress }}</p>
        </div>
      </div>
      <pxw-button
        color="blue"
        size="sm"
        [rounded]="true"
        appareance="solid"
        [loading]="loading()"
        (click)="resetSelection()"
      >
        <pxw-icon class="ui-clickable" icon="edit" />
      </pxw-button>
    </div>
  } @else {
    <pxw-input-text
      #searchTermInput
      name="streetAddress"
      class="address-input-wrapper"
      inputMode="search"
      [required]="required()"
      [custom]="addressDetailsValidation"
      [helper]="helper()"
      [placeholder]="placeholder()"
      [(ngModel)]="searchTerm"
      [displayErrors]="isFormSubmitted()"
      (keyUp)="onSearchTermKeyUp($event)"
      (focusout)="onSearchTermFocusOut()"
    >
      <span class="addon-append">
        <pxw-button
          color="yellow"
          size="sm"
          [rounded]="true"
          [disabled]="searchTerm().length === 0"
          [loading]="loading()"
          (click)="onSearchAddress()"
        >
          <pxw-icon icon="search" />
          {{ searchText() }}
        </pxw-button>
      </span>
      @if (resultsQty() > 0 && !addressDetails() && !loadingDetails()) {
        <div [pxwScrollIntoView]="true">
          <div class="address-info">
            <div class="icon-and-text">
              <pxw-icon class="map-marker" icon="map-marker" size="xs"></pxw-icon>
              <p>{{ selectAddressText() }}</p>
            </div>
          </div>
          <pxw-input-radio-group
            name="predictionList"
            class="prediction-list"
            [options]="searchResults().items"
            [(ngModel)]="selectedPrediction"
            layout="stacked"
          >
            <ng-template #itemTemplate let-result>
              <div class="prediction">
                @for (
                  highlightPart of result.title
                    | pxwMapAutocompleteHightlights: result.highlights || [];
                  track highlightPart
                ) {
                  @if (highlightPart.isHighlight) {
                    <strong class="highlight">{{ highlightPart.titlePart }}</strong>
                  } @else {
                    <span>{{ highlightPart.titlePart }}</span>
                  }
                }
              </div>
            </ng-template>
            <pxw-form-validation
              name="addressDetails"
              style="margin-top: 0.3em"
              [displayErrors]="true"
              [ngModel]="addressDetails()"
              [required]="true"
            />
          </pxw-input-radio-group>
          <pxw-alert size="sm" display="inline-block" type="info">
            <span>{{ wrongAddressesText() }}</span>
            <ng-template #alertDetails>
              <pxw-button
                color="blue"
                size="sm"
                [rounded]="true"
                (click)="openMap()"
                style="white-space: nowrap"
              >
                <pxw-icon icon="map-marker" />
                {{ locateOnMapText() }}
              </pxw-button>
            </ng-template>
          </pxw-alert>
        </div>
      }
    </pxw-input-text>
  }
</div>

@if (addressDetails()) {
  <div class="address-info">
    @let coordinates = addressDetails()?.coordinates;

    @if (displayStaticMapPreview() && coordinates) {
      <div #staticMapContainer class="static-map-container ui-clickable" (click)="openMap()">
        <pxw-stadia-maps-static
          [center]="coordinates"
          [marker]="coordinates"
          [zoom]="15"
          [width]="staticMapContainer.clientWidth"
          [height]="140"
          [objectFit]="'cover'"
        />
      </div>
    }

    <pxw-alert size="sm" display="inline-block" type="info">
      <span>{{ wrongLocationText() }}</span>
    </pxw-alert>
  </div>
} @else if (addressNotFound()) {
  <div class="address-info">
    <pxw-alert size="sm" display="inline-block" type="danger">
      {{ locationNotFoundText() }}
      <ng-template #alertDetails>
        <pxw-button
          color="blue"
          size="sm"
          [rounded]="true"
          (click)="openMap()"
          style="white-space: nowrap"
        >
          <pxw-icon icon="map-marker" />
          {{ selectOnMapText() }}
        </pxw-button>
      </ng-template>
    </pxw-alert>
  </div>
}

<ng-content />

<pxw-stadia-maps-location-popup
  [title]="locateOnMapText()"
  [defaultCenter]="searchCenter()"
  [readyText]="readyText()"
  [mapInstructions]="mapInstructions()"
  [geolocationErrorText]="geolocationErrorText()"
  [(isOpen)]="mapPopupOpen"
  [marker]="addressDetails()?.coordinates || null"
  (markerChange)="onMarkerLocatedOnMap($event)"
/>
